import { jsx as _jsx } from "react/jsx-runtime";
export var Welcome = function () {
    return (_jsx("p", { children: "We connect stablecoins across chains, enabling intent-based payments." }));
};
